import request from "@/utils/request";

export default function agentGetDeviceInfoByDeviceId(deviceId) {
    return request({
        url: `/device/device/agentGetDeviceInfoByDeviceId/${deviceId}`,
    })
}